import {HorizontalList} from 'focus-manager/web';
import * as React from 'react';

import Button from './Button';
import ScalableText from './ScalableText';

const Footer: React.FC = () => (
    <HorizontalList className="footer key-wrapper key-wrapper--detached" loop>
        <Button basis={20}>
            <ScalableText>Cancel</ScalableText>
        </Button>
        <Button basis={45}>
            <ScalableText>New to DAZN? Sign Up</ScalableText>
        </Button>
        <Button basis={35}>
            <ScalableText>Privacy and Terms</ScalableText>
        </Button>
    </HorizontalList>
);

export default Footer;
